/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Detail_Totals_UnfilteredInputs */



/**
* | output |
* | --- |
* | "These figures cover the whole month. The filter narrows the list, not the totals." |
*
* @param {Partner_Detail_Totals_UnfilteredInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_detail_totals_unfiltered = /** @type {((inputs?: Partner_Detail_Totals_UnfilteredInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Detail_Totals_UnfilteredInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Diese Zahlen beziehen sich auf den gesamten Monat. Der Filter schränkt die Liste ein, nicht die Summen.")
	return /** @type {LocalizedString} */ ("These figures cover the whole month. The filter narrows the list, not the totals.")
});